import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ReportHeader from "../../../../Components/ReportHeader";
import { useGenerateReportMutation } from "../../../../features/Report/reportSlice";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import * as XLSX from "xlsx";
import html2pdf from 'html2pdf.js'; // Import html2pdf.js
import { jsPDF } from "jspdf"; // Import jsPDF
import "jspdf-autotable";
import { utils, writeFile } from "xlsx";



const SubReport5 = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const year = queryParams.get("year")
    const ReportType = queryParams.get("reportType")
    const GrpID = queryParams.get("groupId")
    const rows = Array(7).fill();
    const rowsCs = Array(5).fill();
    const [generateReport, { data: reportData, error, isLoading: reportLoading }] = useGenerateReportMutation();

    console.log("REPORT", reportData)




    useEffect(() => {
        const handleReportGeneration = async () => {
            try {
                await generateReport({
                    year,
                    reportType: ReportType,
                    groupId: GrpID,
                }).unwrap();
            } catch (err) {
                console.error("Error generating report:", err);
            }
        };
        handleReportGeneration();
    }, [year, ReportType, GrpID, generateReport]);

    if (reportLoading) return <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "600", fontSize: "20px" }}>Loading...</div>;
    if (error) return <div style={{ height: "100vh", overflow: 'auto', display: "flex", justifyContent: "center", alignItems: "center" }} id="modal_body">
        <div style={{ fontSize: "20px", fontWeight: "600", color: "#000000" }}>No Record Found !</div>
    </div>;


    const tableHeadReport1 = [
        { label: `` },
        { label: ReportType === "Report_5a_DVBE" ? "DVBE Procurement" : "LGBTBE Procurement" },
        { label: `` },
        { label: `${year} Total Procurement` },
    ];


    const generatePDF = () => {
        const doc = new jsPDF();

        const addHeader = (doc) => {
            doc.setFontSize(16);
            doc.setTextColor(40);
            doc.text(handleTitlevalue(), 14, 10); // Title

            doc.setFontSize(10);
            doc.setTextColor(60);
            doc.text(
                handleTitle(),
                14,
                16,
                { maxWidth: 180 }
            ); // Description (wrapped text)

            doc.setLineWidth(0.5);
            // doc.line(10, 22, 200, 22); // Horizontal line
        };

        // Call the header function for the first page
        addHeader(doc);

        let startY = 28;

        // Table Header
        const headers = tableHeadReport1.map(header => header.label);

        // Data for Table Rows (Large Utilities Section)
        const largeUtilitiesData = reportData?.data?.reportData?.LargeUtilities?.Records?.map(item => [
            item?.companyName,
            item?.reportFiveProcurement,
            item?.reportFiveProcurementPercentage,
            item?.totalProcurement
        ]) || [];

        // Total for Large Utilities
        const largeUtilitiesTotal = [
            ["Total",
                reportData?.data?.reportData?.SmallUtilities?.Total?.totalReportFiveProcurement,
                reportData?.data?.reportData?.SmallUtilities?.Total?.totalReportFiveProcurementPercentage,
                reportData?.data?.reportData?.LargeUtilities?.Total?.totalProcurement]
        ];

        // Data for Table Rows (Small Utilities Section)
        const smallUtilitiesData = reportData?.data?.reportData?.SmallUtilities?.Records?.map(item => [
            item?.companyName,
            item?.reportFiveProcurement,
            item?.reportFiveProcurementPercentage,
            item?.totalProcurement
        ]) || [];

        // Total for Small Utilities
        const smallUtilitiesTotal = [
            ["Total",
                reportData?.data?.reportData?.SmallUtilities?.Total?.totalReportFiveProcurement,
                reportData?.data?.reportData?.SmallUtilities?.Total?.totalReportFiveProcurementPercentage,
                reportData?.data?.reportData?.SmallUtilities?.Total?.totalProcurement]
        ];

        // Grand Total Data (already implemented)
        const grandTotalData = [
            ["Grand Total",
                reportData?.data?.reportDetails?.GrandTotalReportFiveProcurement,
                reportData?.data?.reportDetails?.GrandTotalReportFiveProcurementPercentage,
                reportData?.data?.reportDetails?.GrandTotalProcurement]
        ];

        // Prepare all data for table (including section names)
        const tableData = [
            ["Large Utilities", "", "", ""], // Section header for Large Utilities
            ...largeUtilitiesData,
            ...largeUtilitiesTotal,
            ["", "", "", ""], // Empty row for spacing
            ["Small Utilities", "", "", ""], // Section header for Small Utilities
            ...smallUtilitiesData,
            ...smallUtilitiesTotal,
            ["", "", "", ""], // Empty row for spacing
            ...grandTotalData
        ];

        // Add Table to PDF
        doc.autoTable({
            startY: startY,
            head: [headers],
            body: tableData,
            theme: 'grid',
            headStyles: {
                fillColor: [233, 248, 255],  // Light blue background for headers
                textColor: [0, 0, 0],        // Black text
                fontSize: 14,
                fontStyle: 'bold'
            },
            bodyStyles: {
                fontSize: 12,
                textColor: [26, 26, 26],
                halign: 'center',
                valign: 'middle',
                lineColor: [230, 230, 230],  // Light grey line color
                lineWidth: 0.5
            },
            margin: { top: 10, bottom: 20 },
            tableWidth: 'auto',
        });

        // Save the generated PDF
        doc.save('report.pdf');
    };

    const generateCSV = () => {

        const title = [handleTitlevalue()];
        const description = [handleTitle()];
        // Prepare the header
        const headers = tableHeadReport1.map(header => header.label);

        // Function to safely escape commas inside values
        const escapeCommas = (value) => {
            return value && value.includes(",") ? `"${value}"` : value;
        };

        // Data for Table Rows (Large Utilities Section)
        const largeUtilitiesData = reportData?.data?.reportData?.LargeUtilities?.Records?.map(item => [
            escapeCommas(item?.companyName),
            escapeCommas(item?.reportFiveProcurement),
            escapeCommas(item?.reportFiveProcurementPercentage),
            escapeCommas(item?.totalProcurement)
        ]) || [];

        // Total for Large Utilities
        const largeUtilitiesTotal = [
            ["Total",
                escapeCommas(reportData?.data?.reportData?.SmallUtilities?.Total?.totalReportFiveProcurement),
                escapeCommas(reportData?.data?.reportData?.SmallUtilities?.Total?.totalReportFiveProcurementPercentage),
                escapeCommas(reportData?.data?.reportData?.LargeUtilities?.Total?.totalProcurement)]
        ];

        // Data for Table Rows (Small Utilities Section)
        const smallUtilitiesData = reportData?.data?.reportData?.SmallUtilities?.Records?.map(item => [
            escapeCommas(item?.companyName),
            escapeCommas(item?.reportFiveProcurement),
            escapeCommas(item?.reportFiveProcurementPercentage),
            escapeCommas(item?.totalProcurement)
        ]) || [];

        // Total for Small Utilities
        const smallUtilitiesTotal = [
            ["Total",
                escapeCommas(reportData?.data?.reportData?.SmallUtilities?.Total?.totalReportFiveProcurement),
                escapeCommas(reportData?.data?.reportData?.SmallUtilities?.Total?.totalReportFiveProcurementPercentage),
                escapeCommas(reportData?.data?.reportData?.SmallUtilities?.Total?.totalProcurement)]
        ];

        // Grand Total Data (already implemented)
        const grandTotalData = [
            ["Grand Total",
                escapeCommas(reportData?.data?.reportDetails?.GrandTotalReportFiveProcurement),
                escapeCommas(reportData?.data?.reportDetails?.GrandTotalReportFiveProcurementPercentage),
                escapeCommas(reportData?.data?.reportDetails?.GrandTotalProcurement)]
        ];

        // Prepare all data for CSV (including section names)
        const tableData = [
            ["Large Utilities", "", "", ""], // Section header for Large Utilities
            ...largeUtilitiesData,
            ...largeUtilitiesTotal,
            ["", "", "", ""], // Empty row for spacing
            ["Small Utilities", "", "", ""], // Section header for Small Utilities
            ...smallUtilitiesData,
            ...smallUtilitiesTotal,
            ["", "", "", ""], // Empty row for spacing
            ...grandTotalData
        ];

        // Convert the data to CSV
        let csvContent = "data:text/csv;charset=utf-8,";

        // Add title & description at the top
        csvContent += title.join(",") + "\n";
        csvContent += description.join(",") + "\n";
        csvContent += "\n"; // Empty row for spacing

        // Add headers to CSV
        csvContent += headers.join(",") + "\n";

        // Add table rows to CSV
        tableData.forEach(row => {
            csvContent += row.join(",") + "\n";
        });

        // Create a link to download the CSV file
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "report.csv");
        document.body.appendChild(link);

        // Trigger the download
        link.click();
    };

    const generateXLSX = () => {
        // Prepare the header
        const headers = tableHeadReport1.map(header => header.label);

        // Function to safely escape commas inside values
        const escapeCommas = (value) => {
            return value && value.includes(",") ? `"${value}"` : value;
        };

        // Data for Table Rows (Large Utilities Section)
        const largeUtilitiesData = reportData?.data?.reportData?.LargeUtilities?.Records?.map(item => [
            escapeCommas(item?.companyName),
            escapeCommas(item?.reportFiveProcurement),
            escapeCommas(item?.reportFiveProcurementPercentage),
            escapeCommas(item?.totalProcurement)
        ]) || [];

        // Total for Large Utilities
        const largeUtilitiesTotal = [
            ["Total",
                escapeCommas(reportData?.data?.reportData?.SmallUtilities?.Total?.totalReportFiveProcurement),
                escapeCommas(reportData?.data?.reportData?.SmallUtilities?.Total?.totalReportFiveProcurementPercentage),
                escapeCommas(reportData?.data?.reportData?.LargeUtilities?.Total?.totalProcurement)]
        ];

        // Data for Table Rows (Small Utilities Section)
        const smallUtilitiesData = reportData?.data?.reportData?.SmallUtilities?.Records?.map(item => [
            escapeCommas(item?.companyName),
            escapeCommas(item?.reportFiveProcurement),
            escapeCommas(item?.reportFiveProcurementPercentage),
            escapeCommas(item?.totalProcurement)
        ]) || [];

        // Total for Small Utilities
        const smallUtilitiesTotal = [
            ["Total",
                escapeCommas(reportData?.data?.reportData?.SmallUtilities?.Total?.totalReportFiveProcurement),
                escapeCommas(reportData?.data?.reportData?.SmallUtilities?.Total?.totalReportFiveProcurementPercentage),
                escapeCommas(reportData?.data?.reportData?.SmallUtilities?.Total?.totalProcurement)]
        ];

        // Grand Total Data (already implemented)
        const grandTotalData = [
            ["Grand Total",
                escapeCommas(reportData?.data?.reportDetails?.GrandTotalReportFiveProcurement),
                escapeCommas(reportData?.data?.reportDetails?.GrandTotalReportFiveProcurementPercentage),
                escapeCommas(reportData?.data?.reportDetails?.GrandTotalProcurement)]
        ];

        // Prepare all data for XLSX (including section names)
        const tableData = [
            ["Large Utilities", "", "", ""], // Section header for Large Utilities
            ...largeUtilitiesData,
            ...largeUtilitiesTotal,
            ["", "", "", ""], // Empty row for spacing
            ["Small Utilities", "", "", ""], // Section header for Small Utilities
            ...smallUtilitiesData,
            ...smallUtilitiesTotal,
            ["", "", "", ""], // Empty row for spacing
            ...grandTotalData
        ];

        // Create a new workbook
        const wb = XLSX.utils.book_new();

        // Add data to worksheet
        const ws = XLSX.utils.aoa_to_sheet([
            [handleTitlevalue()],
            [handleTitle()],
            [],
            headers,
             ...tableData]);

        // Append worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, "Report");

        // Write the workbook to a binary string and trigger download
        XLSX.writeFile(wb, "report.xlsx");
    };

    const downloadHandle = (val) => {
        // console.log("VL", val)
        if (val === 1) {
            generatePDF()
        }
        if (val === 2) {
            generateXLSX()
        }
        if (val === 3) {
            generateCSV()
        }

    }

    const handleAllvalues = (index, value) => {
        if (index === 0) return value?.companyName
        if (index === 1) return value?.reportFiveProcurement
        if (index === 2) return value?.reportFiveProcurementPercentage
        if (index === 3) return value?.totalProcurement
    }
    const handleTotal = (index) => {
        if (index === 0) return "Total"
        if (index === 1) return reportData?.data?.reportData?.LargeUtilities?.Total?.totalReportFiveProcurement
        if (index === 2) return reportData?.data?.reportData?.LargeUtilities?.Total?.totalReportFiveProcurementPercentage
        if (index === 3) return reportData?.data?.reportData?.LargeUtilities?.Total?.totalProcurement
    }
    const handleGrandTotal = (index) => {
        if (index === 0) return "Grand Total"
        if (index === 1) return reportData?.data?.reportDetails?.GrandTotalReportFiveProcurement
        if (index === 2) return reportData?.data?.reportDetails?.GrandTotalReportFiveProcurementPercentage
        if (index === 3) return reportData?.data?.reportDetails?.GrandTotalProcurement
    }


    const getCellStyle = (cellIndex, isHeader = false) => ({
        fontWeight: isHeader || cellIndex === 0 ? "700" : "400",
        fontSize: "14px",
        color: "#1A1A1A",
        textAlign: "center",
        border: "1px solid #E6E6E6",
        borderTop: cellIndex === 0 ? "none" : "1px solid #E6E6E6",
        backgroundColor: "transparent",
    });

    const renderTableRow = (data, isHeader = false) => (
        <TableRow sx={{ height: isHeader ? "62px" : "45px" }} key={data}>
            {Array(4).fill(null).map((_, cellIndex) => (
                <TableCell key={cellIndex} sx={getCellStyle(cellIndex, isHeader)}>
                    {cellIndex === 0 ? data : ""}
                </TableCell>
            ))}
        </TableRow>
    );
    const renderTableRowTotal = (data, isHeader = false) => (
        <TableRow sx={{ height: isHeader ? "62px" : "45px" }} key={data}>
            {Array(4).fill(null).map((_, cellIndex) => (
                <TableCell key={cellIndex} sx={getCellStyle(cellIndex, isHeader)}>
                    {handleTotal(cellIndex)}
                </TableCell>
            ))}
        </TableRow>
    );
    const renderTableRowGrand = (data, isHeader = false) => (
        <TableRow sx={{ height: isHeader ? "62px" : "45px" }} key={data}>
            {Array(4).fill(null).map((_, cellIndex) => (
                <TableCell key={cellIndex} sx={getCellStyle(cellIndex, isHeader)}>
                    {handleGrandTotal(cellIndex)}
                </TableCell>
            ))}
        </TableRow>
    );

    const renderDataRow = (item, handleValues) => (
        <TableRow sx={{ height: "45px" }} key={item.id}>
            {Array(4).fill(null).map((_, cellIndex) => (
                <TableCell key={cellIndex} sx={getCellStyle(cellIndex)}>
                    {handleValues(cellIndex, item)}
                </TableCell>
            ))}
        </TableRow>
    );


    const handleTitlevalue = () => {
        switch (ReportType) {
            case "Report_1a_Large":
                return "Table 1A"
            case "Report_1a_Small":
                return "Table 1B"
            case "Report_1a_CCA":
                return "Table 1C"
            case "Report_2a_TotalSpend":
                return "Table 2A"
            case "Report_2a_Subcontracting":
                return "Table 2B"
            case "Report_3a_Large":
                return "Table 3A"
            case "Report_3b_Small":
                return "Table 3B"
            case "Report_3c_Large":
                return "Table 3C"
            case "Report_3d_Small":
                return "Table 3D"
            case "Report_4a_Large":
                return "Table 4A"
            case "Report_4a_Small":
                return "Table 4B"
            case "Report_5a_DVBE":
                return "Table 5A"
            case "Report_5a_LGBTBE":
                return "Table 5B"
            default:
                return "Table";
        }
    }

    const handleTitle = () => {
        if (ReportType === "Report_5a_DVBE") {
            return "DVBE Procurement for Large and Small Utilities"
        }
        if (ReportType === "Report_5a_LGBTBE") {
            return "LGBTBE Procurement for Large and Small Utilities"
        }
    }

    // { value: 'Report_5a_DVBE', label: 'Report 5A DVBE' },
    // { value: 'Report_5b_LGBTBE', label: 'Report 5B LGBTBE'},

    return (
        <div id="report_generation">
            <ReportHeader handleClick={reportData?.data?.reportData?.length < 1 ? () => { } : downloadHandle} title={handleTitle()} year={year} report={ReportType}  logo={reportData?.data?.logo}/>
            {reportData?.data?.reportData?.length < 1 ?
                <div style={{ height: "calc(100vh - 225px)", overflow: 'auto', display: "flex", justifyContent: "center", alignItems: "center" }} id="modal_body">
                    <div style={{ fontSize: "20px", fontWeight: "600", color: "#000000" }}>No Record Found !</div>
                </div>
                :
                <div style={{ height: "calc(100vh - 225px)", overflow: 'auto' }} id="modal_body">

                    <TableContainer component={Paper} sx={{ marginTop: "0px" }}>
                        <Table aria-label='customized table'>
                            <TableHead>
                                <TableRow>
                                    {tableHeadReport1.map((header, id) => (
                                        <TableCell key={id} align='center' style={{
                                            background: id === 0 ? "#fff" : "#E9F8FF",
                                            fontWeight: "700",
                                            color: "#000000",
                                            fontSize: "16px",
                                            letterSpacing: "0.2px"
                                        }}>
                                            {header.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/* Large Utilities Section */}
                                {renderTableRow("Large Utilities", true)}
                                {renderTableRow("", false)}

                                {reportData?.data?.reportData?.LargeUtilities?.Records?.map(item => renderDataRow(item, handleAllvalues))}

                                {renderTableRowTotal("", true)}

                                {/* Small Utilities Section */}
                                {renderTableRow("Small Utilities", true)}
                                {renderTableRow("", false)}

                                {reportData?.data?.reportData?.SmallUtilities?.Records?.map(item => renderDataRow(item, handleAllvalues))}

                                {renderTableRowTotal("", true)}

                                {/* Grand Total Section */}
                                {renderTableRowGrand("", true)}
                            </TableBody>
                        </Table>
                    </TableContainer>

                </div>
            }
        </div>
    )
}

export default SubReport5